import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Sanctuary from './components/Sanctuary';
import Experiences from './components/Experiences';
import Gallery from './components/Gallery';
import Logistics from './components/Logistics';
import Dining from './components/Dining';
import Booking from './components/Booking';
import Footer from './components/Footer';
import FloatingElements from './components/FloatingElements';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <FloatingElements />
        <Header />
        
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={
              <motion.main
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6 }}
              >
                <Hero />
                <Sanctuary />
                <Experiences />
                <Gallery />
                <Logistics />
                <Dining />
                <Booking />
              </motion.main>
            } />
          </Routes>
        </AnimatePresence>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;